// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__LFpfx","noInteraction":"EventWrapper_noInteraction__1b9Yo"};